import PropTypes from "prop-types";
import { useState } from "react";
import { Box } from "@mui/material";
import { getLDAPUserBySearchField } from "../../../components/Api/Getters";

function CustomTabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && <Box sx={{ p: 3 }}>{children}</Box>}
		</div>
	);
}
CustomTabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired,
};

const searchFields = [
	{
		name: "CCID",
		value: "uid",
	},
	{
		name: "EMPID",
		value: "employeeNumber",
	},
];

export default function LDAPSearch(props) {
	const { value, token } = props;
	const [searchStatus, setSearchStatus] = useState("");
	const [searchFieldValue, setSearchFieldValue] = useState("");
	const [searchResults, setSearchResults] = useState([]);
	const [searchValue, setSearchValue] = useState("");

	const handleSearchChange = (event) => {
		setSearchFieldValue(event.target.value);
	};

	const handleLDAPSearch = async () => {
		try {
			const response = await getLDAPUserBySearchField(
				token,
				searchFieldValue,
				searchValue
			);
			if (!response || response.length === 0) {
				// Handle the case where the response is empty/null
				setSearchStatus("User not found in LDAP.");
				return;
			}
			setSearchResults((prevSearchResults) => {
				const userExists = prevSearchResults.some(
					(user) => user.empid === response.empid
				);
				if (!userExists) {
					return [...prevSearchResults, response];
				}
				return prevSearchResults;
			});
		} catch (error) {
			setSearchStatus("Error searching for user");
			console.error("Search error:", error);
		}
	};
	return (
		<CustomTabPanel
			value={value}
			index={2}
		>
			<div className="w-full flex flex-col items-center justify-center mt-8 pb-10">
				<select
					className="mb-4 px-4 py-2 border border-gray-400 rounded-md text-gray-700"
					onChange={handleSearchChange}
					value={searchFieldValue}
				>
					<option
						value=""
						disabled
					>
						Select Search Field
					</option>
					{searchFields.map((option) => (
						<option
							key={option.value}
							value={option.value}
						>
							{option.name}
						</option>
					))}
				</select>
				<input
					className="border-2 rounded-md px-4 py-2 bg-gray-100 text-black border-green-800 mb-4"
					type="text"
					onChange={(e) => setSearchValue(e.target.value)}
					placeholder="Search Value"
				/>
				<button
					disabled={!searchFieldValue || !searchValue}
					onClick={handleLDAPSearch}
					className={`disabled:bg-gray-400 disabled:border-gray-500 bg-green-700 hover:bg-green-800 text-white border-green-800 border-2 rounded-md px-4 py-2`}
				>
					Search
				</button>
				{searchStatus && <div className="text-red-500">{searchStatus}</div>}
				<div className="mt-4 max-h-[60dvh] overflow-y-auto w-[50dvw] ">
					<table className="table-auto border-collapse border border-gray-400 w-full">
						<thead>
							<tr>
								<th className="border border-gray-400 px-4 py-2">CCID</th>
								<th className="border border-gray-400 px-4 py-2">EMPID</th>
								<th className="border border-gray-400 px-4 py-2">First Name</th>
								<th className="border border-gray-400 px-4 py-2">Last Name</th>
								<th className="border border-gray-400 px-4 py-2">Email</th>
							</tr>
						</thead>
						<tbody>
							{searchResults &&
								searchResults.map((row, rowIndex) => (
									<tr key={rowIndex}>
										<td className="border border-gray-400 px-4 py-2">
											{row.ccid}
										</td>
										<td className="border border-gray-400 px-4 py-2">
											{row.empid}
										</td>
										<td className="border border-gray-400 px-4 py-2">
											{row.firstName}
										</td>
										<td className="border border-gray-400 px-4 py-2">
											{row.lastName}
										</td>
										<td className="border border-gray-400 px-4 py-2">
											{row.email}
										</td>
									</tr>
								))}
						</tbody>
					</table>
				</div>
			</div>
		</CustomTabPanel>
	);
}
